import { render } from "./creating_a_policy.html?vue&type=template&id=1aff3e6e&external"
import script from "./creating_a_policy.js?vue&type=script&lang=js&external"
export * from "./creating_a_policy.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__